export function normalizeMemberTags(raw) {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw
      .map((value) => {
        if (!value) return '';
        if (typeof value === 'string') return value.trim();
        if (typeof value === 'object' && value.name) return String(value.name).trim();
        return '';
      })
      .filter(Boolean);
  }

  if (typeof raw !== 'object') return [];

  const out = [];

  Object.entries(raw).forEach(([key, value]) => {
    if (value === true || value === 1 || value === 'true') {
      out.push(String(key).trim());
      return;
    }

    if (value === false || value === 0 || value == null || value === '') return;

    const values = Array.isArray(value) ? value : [value];
    values.forEach((entry) => {
      if (entry == null || entry === '') return;
      if (typeof entry === 'string') {
        out.push(entry.trim());
        return;
      }
      if (typeof entry === 'object' && entry.name) {
        out.push(String(entry.name).trim());
        return;
      }
      if (typeof entry === 'object') {
        Object.entries(entry).forEach(([innerKey, innerValue]) => {
          if (innerValue === true || innerValue === 1 || innerValue === 'true') {
            out.push(String(innerKey).trim());
          }
        });
      }
    });
  });

  return Array.from(new Set(out.filter(Boolean)));
}
